import { useTranslation } from "react-i18next";
import { useAxios } from "../../useAxios"
import { useQuery } from "@tanstack/react-query";
import { Question } from "@types";

export const useGetExamGroupQuestions = (groupId?: string) => {

    const axios = useAxios();
    const {t} = useTranslation();

    const getExamGroupQuestions = async (groupId?: string):Promise<{items: Question[]}> => {
        try {
            const response = await axios.get(`/api/examgroup/${groupId}/questions`);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getExamGroupQuestions"));
        }
    }

    return useQuery({queryKey: ["examGroupQuestions", groupId], queryFn: () => getExamGroupQuestions(groupId), staleTime: Infinity, enabled: !!groupId})
}